<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/invoicing-and-project-management-software.mjs";
</script>
